<template>
  <section id="faq">
    <article class="sections-container">
      <div
        v-for="(section, i) in sections"
        :key="'faq-section-' + i"
        :ref="'section-' + i"
      >
        <HowToSection :section="section" :sectionKey="i" />
      </div>
    </article>

    <article class="sections-shortcuts">
      <ul>
        <li class="list-header slate-bold">{{ shortcutHeading }}</li>
        <li v-for="(section, i) in sections" :key="'faq-shortcut' + i">
          <a
            :href="'#section-' + i"
            @click="gotToSection(i)"
            :class="{ selected: currentSection === i }"
            >{{ section.title }}</a
          >
        </li>
      </ul>
    </article>
  </section>
</template>

<script>
import HowToSection from "@/components/Dashboard/HowTo/HowToSection.vue";
export default {
  props: {
    sections: {
      type: Array,
    },
    shortcutHeading: {
      type: String,
    },
  },
  name: "HowTo",

  data() {
    return {
      currentSection: 0,
    };
  },

  methods: {
    openSection(section) {
      this.currentSection = section;
    },
    closeSection() {
      this.currentSection = null;
    },

    gotToSection(section) {
      this.currentSection = section;
      this.$nextTick(() => {
        this.$refs["section-" + section][0].scrollIntoView({
          behavior: "smooth",
        });
      });
    },
  },

  components: {
    HowToSection,
  },
};
</script>

<style lang="scss">
#faq {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 5%;
  .sections-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 70%;
  }

  .sections-shortcuts {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    margin-bottom: 5%;
    margin-top: 0;
    overflow: hidden;
    position: sticky;
    top: 1rem;
    width: 20%;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      width: 100%;

      li {
        margin: 0;
        padding: 0;
        &.list-header {
          background-color: $dark;
          color: white;
          display: flex;
          padding: 1rem 1.25rem;
          padding-bottom: 1rem;
        }
        a {
          background-color: $dark;
          color: $placeholder;
          display: flex;
          padding: 1rem 1.25rem;
          border-bottom: 1px solid $placeholder;
          &.selected,
          &:hover,
          &:active {
            color: white;
            text-decoration: underline;
            border-bottom: 1px solid white;
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .sections-container {
      width: 50%;
    }
    .sections-shortcuts {
      width: 30%;
    }
  }
}
</style>